import React, { useState, useEffect } from 'react';
import adamTen from './assets/bg-a10.jpg';

const DesktopBackground = () => {
  const [isDesktop, setIsDesktop] = useState(false);

  useEffect(() => {
    const checkIfDesktop = () => {
      setIsDesktop(window.innerWidth > 1024);
    };
    checkIfDesktop();
    window.addEventListener('resize', checkIfDesktop);
    return () => window.removeEventListener('resize', checkIfDesktop);
  }, []);

  if (!isDesktop) return null;

  return (
    <div
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100vw',
        height: '100vh',
        zIndex: 0,
        background: `url(${adamTen}) no-repeat center center`,
        backgroundSize: 'cover',
        pointerEvents: 'none',
        display: 'block',
      }}
    />
  );
};

export default DesktopBackground; 